module.exports = __webpack_public_path__ + "img/dreamweavers-7.006359cd.webp";